import React from 'react';
import '../style/Home.css';

const Home = () => {
    return(
        <>
            <div class='home_container'>
                <div class='img_contain'>
                    <h1>Welcome to the ImagePicker</h1>
                    <br />
                    <h3 id='para-1' class='para'>Where you can download different categories of images.</h3>
                    <h3 id='para-2' class='para'>with complete HD or High Resolution.</h3>
                </div>
            </div>
        </>
    )
}

export default Home;